import {
	createSlice,
	current
} from '@reduxjs/toolkit';
import {
	getGuideDetailList,
	addNewGuideDetail,
	updateGuideDetail,
	deleteGuideDetail,
	getGuideDetail,
	warehouseSendFromStock,
	warehouseSendFromGuideLines,
} from './thunk';

export const initialState = {
	itemGuideDetailList: [],
	itemGuideDetailDetail: null,
	isGuideDetailLoading: false,
	isGuideDetailSuccess: false,

	guideDetailList: [],
	guideDetailListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	isReceiving: false,
	isReceived: false,
	isReceptionError: false,
	isSending: false,
	isSended: false,
	isSendError: false,
	requireCloseModal: false,
	requireReloadSelectionItemsGrid: false
};

const GuideDetailSlice = createSlice({
	name: 'GuideDetails',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
		setRequireReloadSelectionItemsGrid(state, action) {
			state.requireReloadSelectionItemsGrid = action.payload;
		},
		restartSend(state, action){
			state.isSending = false
			state.isSended = false
			state.isSendError = false
		}
	},
	extraReducers: builder => {
		builder.addCase(getGuideDetail.fulfilled, (state, action) => {
			state.isGuideDetailLoading = false;
			state.isGuideDetailSuccess = true;
			state.itemGuideDetailDetail = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getGuideDetail.pending, state => {
			state.isGuideDetailLoading = true;
			state.isGuideDetailSuccess = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getGuideDetail.rejected, (state, action) => {
			state.isGuideDetailLoading = false;
			state.isGuideDetailSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
		});

		builder.addCase(getGuideDetailList.pending, state => {
			state.isGuideDetailSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getGuideDetailList.fulfilled, (state, action) => {
			state.itemGuideDetailList = action.payload;
			state.guideDetailList = action.payload;
			state.isLoadingList = false;
			state.isGuideDetailSuccess = true;

			let guideDetailListSelect = [];
			action.payload.map(item =>
				guideDetailListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.guideDetailListSelect = guideDetailListSelect;
		});
		builder.addCase(getGuideDetailList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isGuideDetailSuccess = true;
		});
		builder.addCase(addNewGuideDetail.fulfilled, (state, action) => {
			state.itemGuideDetailList.push(action.payload);
			state.guideDetailList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(addNewGuideDetail.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewGuideDetail.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});

		builder.addCase(updateGuideDetail.fulfilled, (state, action) => {
			state.itemGuideDetailList = state.itemGuideDetailList.map(guideDetail =>
				guideDetail.guideDetailname === action.payload.old_guideDetail
					? { ...guideDetail, ...action.payload.updated_guideDetail }
					: guideDetail
			);
			state.guideDetailList = state.guideDetailList.map(guideDetail =>
				guideDetail._id.toString() === action.payload._id.toString()
					? { ...guideDetail, ...action.payload }
					: guideDetail
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(updateGuideDetail.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updateGuideDetail.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteGuideDetail.fulfilled, (state, action) => {
			state.itemGuideDetailList = current(state.itemGuideDetailList).filter(
				item => item._id !== action.payload._id
			);
			state.guideDetailList = current(state.guideDetailList).filter(item =>
				item._id !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
			state.requireCloseModal = true;
		});
		builder.addCase(deleteGuideDetail.pending, (state, action) => {
			state.isLoadingList = true;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
		});
		builder.addCase(deleteGuideDetail.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDelete = true;
		});
		builder.addCase(warehouseSendFromStock.fulfilled, (state, action) => {
			state.isSending = false;
			state.isSended = true;
			state.isSendError = false;
			state.requireCloseModal = true;
			state.requireReloadSelectionItemsGrid = true;
		});
		builder.addCase(warehouseSendFromStock.pending, state => {
			state.isSending = true;
			state.isSended = false;
			state.isSendError = false;
		});
		builder.addCase(warehouseSendFromStock.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isSending = false;
			state.isSended = false;
			state.isSendError = true;
			state.requireCloseModal = false;
		});
		builder.addCase(warehouseSendFromGuideLines.fulfilled, (state, action) => {
			state.isSending = false;
			state.isSended = true;
			state.isSendError = false;
			state.requireCloseModal = true;
			state.requireReloadSelectionItemsGrid = true;
		});
		builder.addCase(warehouseSendFromGuideLines.pending, state => {
			state.isSending = true;
			state.isSended = false;
			state.isSendError = false;
		});
		builder.addCase(warehouseSendFromGuideLines.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isSending = false;
			state.isSended = false;
			state.isSendError = true;
			state.requireCloseModal = false;
		});
	},
});

export const {
	setRequireCloseModal,
	setRequireReloadSelectionItemsGrid,
	restartSend
} = GuideDetailSlice.actions;

export default GuideDetailSlice.reducer;
